import { BCMSRecord, Workflow, useBCMSContext, useParams } from "@bcm-dev/bcms-vite";
import Classes from "model";
import EDEStatementsEnrollmentProfilePage from "components/EDEStatements/pages/EDEStatementsEnrollmentProfilePage";
import EDEStatementsEnrollmentAgreementPage from "components/EDEStatements/pages/EDEStatementsEnrollmentAgreementPage";
import EDEStatementsEnrollmentPreferencesPage from "components/EDEStatements/pages/EDEStatementsEnrollmentPreferencesPage";
import EDEStatementsEnrollmentPreferencesConfirmationPage from "components/EDEStatements/pages/EDEStatementsEnrollmentPreferencesConfirmationPage";
import EDEStatementsPage from "components/EDEStatements/pages/EDEStatementsPage";

// Steps of the workflow
const steps = [ 
  EDEStatementsEnrollmentProfilePage,
  EDEStatementsEnrollmentAgreementPage,
  EDEStatementsEnrollmentPreferencesPage,
  EDEStatementsEnrollmentPreferencesConfirmationPage,
  EDEStatementsPage
]; 

/**
 * @function EDEStatementsEnrollmentWorkflow
 * @param {Void} - No arguments are passed.
 * @returns {React.Component}
 * @exported true
 * @description The workflow component for the "EDE Statements Enrollment" page.
 */
export default function EDEStatementsEnrollmentWorkflow(props) {
    const controller = useBCMSContext();
    const { stepID } = useParams();

    // Get the inital state of the workflow
    const value = getDefault(controller);

    // Return the workflow component
    return <Workflow value={ value } steps={ steps } step={ stepID } />
}
// Return the steps of the workflow
export const getWorkflowSteps = () => steps;

/**
 * @function getDefault
 * @param {Controller} controller - A global controller.
 * @returns {Object}
 * @exported true
 * @description Function to get the default state of the workflow
 */
export const getDefault = controller => {
    BCMSRecord.globalControllerFor(Classes, controller);

    // Return the default workflow state
    return {
        ui: {
          
        },
        data: {
          
        }
    };
};